import { PropType, computed, defineComponent } from "vue";
import { OfferJson, OrderJson } from "../../OrderForm";
import Utils from "../../utils/Utils";
import Offers from "../../components/Offers";
import ArticleLayout, { ArticleFigure } from "../../layouts/ArticleLayout";

export default defineComponent({
    components: {
        ArticleLayout,
        Offers,
    },

    template: `
        <ArticleLayout class="StepVoucherOffers" :wrapper="null" :figure="figure">
            <h1 v-if="!figure" class="title-1">Oferta Promocyjna</h1>

            <Offers
                :offers="offers"
                :code="options.code"

                :featured_initialslide="0"

                @offer:click="onOfferClick"
            />
        </ArticleLayout>
    `,

    emits: [
        'offer:select',
    ],

    props: {
        options: { type: Object as PropType<OrderJson>, required: true },
    },

    setup(props, ctx) {
        const offers = computed(() => {
            return props.options.code.items.map(v => v.offer);
        });

        const figure = computed(() => {
            if (!props.options?.code?.heroImage) {
                return null;
            }

            const code = props.options.code;

            const f: ArticleFigure = {
                image: code.heroImage,
                title: code.heroTagline1,
                subtitle: code.heroTagline2,
            };

            return f;
        });

        async function onOfferClick(offer: OfferJson) {
            await Utils.setCart('code-offer', {
                offer_id: offer.id,
            });

            ctx.emit('offer:select', offer);
        }

        return {
            offers,
            figure,

            onOfferClick,
        };
    },
});
